import { resources, SUPPORTED_LANGS } from "@/i18n";

import { useEffect, useState } from "react";
import { default as languageService } from "../services/language";
import { i18n } from "@/config";

const useLanguageProvider = () => {
  const [loaded, setLoaded] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  useEffect(() => {
    fetchTranslations();
  }, [])

  const fetchTranslations = async () => {
    const languages = SUPPORTED_LANGS;

    const promises = languages.map(lang => {
      return languageService.fetchTranslations(lang)
        .then(res => {
          i18n.addResourceBundle(lang, 'common', res);
          return lang;
        })
        .catch(err => {
          const fileLangName = lang as keyof typeof resources;
          const fileLangResourceObj = resources[fileLangName];
          const [namespace, resource] = Object.entries(fileLangResourceObj)[0];
          
          i18n.addResourceBundle(lang, namespace, resource);
          return lang;
        });
    });

    await Promise.all(promises);

    setLoaded(true);
    setIsFetching(false);
  }

  return {
    loaded,
    isFetching,
  }
}

export default useLanguageProvider;